import axios from 'axios';
import store from '../store';
import {showMessage} from "@/lib/toasted";

// Определяем базовый URL в зависимости от окружения
let baseURL;

if (process.env.NODE_ENV === 'production') {
    // На проде используем обычный URL без авторизации
    baseURL = process.env.VUE_APP_BASE_URL + '/api';
} else {
    // В разработке добавляем базовую авторизацию в URL
    // const credentials = 'lukmarket-api-lukoil-shop:lukmarket-api-lukoil-shop';
    // baseURL = process.env.VUE_APP_BASE_URL.replace(
    //     /^(https?:\/\/)/,
    //     `$1${credentials}@`
    // ) + '/api';
    baseURL = process.env.VUE_APP_BASE_URL + '/api';
}

const instance = axios.create({
    baseURL,
    timeout        : 120000,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'Cache-Control': 'no-cache'
    }
});

instance.interceptors.request.use(config => {
    const token = store.state.account.token;

    // Добавляем Bearer token если он есть
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }

    return config;
});

instance.interceptors.response.use(res => res, async err => {
    const {status} = err.response;

    if (status === 401) {
        await store.dispatch('account/logout', {}, {root: true});
        showMessage('error', 'Сессия истекла! Пожалуйста, авторизуйтесь заново');
    } else if (status === 500) {
        const {data: {status, message}} = err.response;
        showMessage(status, message)
    }

    return Promise.reject(err);
});

export const post = async (url, data = {}, config = {}) => (await instance.post(url, data, config));
export const remove = async (url, config = {}) => (await instance.delete(url, config));
export const patch = async (url, data = {}, config = {}) => (await instance.patch(url, data, config));
export const put = async (url, data = {}, config = {}) => (await instance.put(url, data, config));
export const get  = async (url, params, config = {}) => (await instance.get(url, {params, ...config}));


export const base_url = process.env.VUE_APP_BASE_URL;